<template>
    <modal class="couponVerifyModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">卡券核销<span class="close" @click="hide()">×</span></div>
        <div class="The-head flexBox">
            <div class="left-box">
                请输入或扫码：
                <div class="from-input">
                    <i v-if="$webBrowser?.isMobile?.Android" class="iconfont icon-a-saoma13x" @click="scanCode"></i>
                    <i v-else class="iconfont icon-a-saoma13x"></i>
                    <input type="text" ref="input" v-mode-en class="key-focus" data-model='idCode' v-model="idCode" @keyup.enter="readCard()" />
                </div>
                <button class="btn" @click="readCard()">查询</button>
            </div>
            <div class="coupons-box">
                <!-- <div class="name">券名称:</div> -->
                <div class="list-box">
                    <div class="li-box" v-for="item in ticketInfos" :key="item">
                        <div class="item-li" :class="{selected:item.Check}" @click="onTicket(item)" :key="item">
                            <div class="coupons-name">
                                <div class="coupon-left" :class="{selected:item.Check==true}">
                                    <div class="left-txt cika" v-if="item.Coupon_Type==4"> 
                                        <div class="count"><span>{{item.Time_Card?.times_count-item.Time_Card?.times_used}}</span>次卡</div>
                                        <div class="used">已用{{item.Time_Card?.times_used}}次</div>
                                    </div>
                                    <div class="left-txt" v-else>
                                        <span class="m">¥</span>
                                        <span class="y">{{item.Coupon_Amount}}</span>
                                    </div>
                                </div>
                                <div class="coupon-right" :class="{selected:item.Check==true}">
                                    <div class="coupon-top">
                                        <span class="tk-txt">{{item.Coupon_Name}}</span>
                                        <span class="tk-time">有效期:{{new Date(item.Start_Time).Format("yyyy-MM-dd")}}至{{new Date(item.End_Time).Format("yyyy-MM-dd")}}</span>
                                    </div>
                                    <span class="cou-ge"></span>
                                    <div class="coupon-bottom">
                                        详细信息
                                        <div class="triangle" v-show="item.extendShow==false" @click="extenClick(item)"></div>
                                        <div class="triangles" v-show="item.extendShow==true" @click="extenClick(item)"></div>
                                    </div>
                                    <div class="extend" v-show="item.extendShow==true">
                                        <span style="margin-left:-120px;" v-show="item.Consume_MinMoney>0">使用说明</span>
                                        <span class="ex-span" v-show="item.Consume_MinMoney>0" >消费满{{item.Consume_MinMoney}}元可使用此券</span>
                                    </div>
                                    <i class="iconfont icon-gou-fine"></i>
                                </div>
                            </div>
                        </div>
                        <div class="huan-bnt" v-show="item.Check && couponItemList?.length>0" @click="selectItemShow=true">换菜</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="food-box">
                <div class="title-box">
                    <div class="flex-1">菜品信息<span v-show="posFoodSetMealInfos?.SetMealInfo">: {{posFoodSetMealInfos?.SetMealInfo?.Eat_TcName}} x1/份</span> 
                    </div>
                    <el-switch v-show="isReplaceShow" v-model="isReplace" inline-prompt active-text="套餐子菜替换" inactive-text="" active-color="#13ce66" inactive-color="#cecece"></el-switch>
                </div>
                <!--套餐展示-->
                <div class="setMeal-box" v-if="posFoodSetMealInfos?.Is_SetMeal">
                    <div class="left-nav" ref="nav" >
                        <div class="nav-li selected" data-index="0"><span>全部</span></div>
                        <div class="nav-li" v-for="(item,index) in posFoodSetMealInfos?.SetMealInfo?.SetMealKinds" :key="item" :data-index="index"><span>{{item.Kind_Name}}</span></div>
                    </div>
                    <div class="right-box">
                        <div class="meal-box" v-mouse-scroll v-nav-roll="{nav:'nav'}">
                            <div class="pane-box" v-for="item in posFoodSetMealInfos?.SetMealInfo?.SetMealKinds" :key="item">
                                <div class="title">
                                    {{item.Kind_Name}}<span>（必选项，最少选{{item.Select_Number}}份，最多选{{item.Count_Number}}份）</span>
                                </div>
                                <div class="item-box">
                                    <div class="item-li selected" v-for="set in item.SetMealDetails" :key="set">
                                        
                                        <div class="tit" :class="{selected:set.Is_Selected}" >
                                            <tag-sold-out v-if="(set.replaceItem && set.replaceItem.Is_SoldOut) || (!set.replaceItem && set.Is_SoldOut)"></tag-sold-out>
                                            <div class="name" @click="foodClick(set,item)" :style="{'padding-right':isReplace && (item.ReplaceType==1 || item.ReplaceType==2) ?'55px':0}">
                                                <span class="inlineNowrap2">
                                                    {{set.replaceItem?set.replaceItem.Food_Name:set.Food_Name}}
                                                    <span v-if="set.Food_TcPrice>0">（加价：{{set.Food_TcPrice}}元）</span>
                                                </span>
                                                <i class="iconfont icon-gou-fine"></i>

                                                <div class="replace-bnt" v-if="isReplace && (item.ReplaceType==1 || item.ReplaceType==2)" @click.stop="replaceClick(item,set)">替换</div>
                                                <div class="unit">{{set.replaceItem?set.replaceItem.Food_Size:set.Food_Size}}</div>
                                            </div>
                                            <div class="flavour_bnt"  @click="flavourClick(set)">
                                                <i class="iconfont icon-bianji"></i>
                                            </div>
                                        </div>
                                        <div class="flex-box" v-if="set.Is_Selected">
                                            <div class="tally-box" >
                                                <template v-if="set.Is_Fixed">
                                                    <div class="num fixedNum">×{{set.Food_Number}}</div>
                                                </template>
                                                <template v-else>
                                                    <div class="bnt-jian" :class="{fixed:set.Is_Fixed}" @click="setMealNumreduce(set)"><b class="iconfont icon-jian"></b></div>
                                                    <div class="num">{{set.Food_Number}}</div>
                                                    <div class="bnt-jia" :class="{fixed:set.Is_Fixed}" @click="setMealNumAdd(set,item)"><b class="iconfont icon-jia"></b></div>
                                                </template>
                                            </div>
                                            <div class="describe nowrap2" v-if="set._Eat_MasName">要求：{{set._Eat_MasName}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="setMeal-box" v-else-if="posFoodSetMealInfos">
                    <div class="left-nav" ref="nav" >
                        <div class="nav-li selected" data-index="0"><span>全部</span></div>
                    </div>
                    <div class="right-box">
                        <div class="meal-box" v-mouse-scroll v-nav-roll="{nav:'nav'}">
                            <div class="pane-box">
                                <div class="item-box">
                                    <div class="item-li selected">
                                        <div class="tit selected">
                                            <tag-sold-out v-if="posFoodSetMealInfos.Is_SoldOut"></tag-sold-out>
                                            <div class="name">
                                                <span class="inlineNowrap2">
                                                    {{posFoodSetMealInfos.Food_Name}}
                                                </span>
                                                <i class="iconfont icon-gou-fine"></i>
                                                <div class="unit">x1/{{posFoodSetMealInfos?.Food_Size}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="taste-box">
                <div class="masKind" @click="masClick()">请选择口味与做法></div>
                <div class="deman">
                    <div class="dema-div" v-for="mas in choosemasKind" :key="mas" @click="deleteMasClick(mas)">
                        <div class="nowrap">{{mas.Mas_Name}}</div>
                        <div class="dema-x">x</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="cancelConfirm()">核销</button>
        </div>
        <!-- 菜品要求操作 -->
        <modal-load :isShow="demandShow" isUnload>
            <demand-model :isShow="demandShow" @closeModel="demandShow=false,BindPosFoods=null"
                :masKindsList="masKindsList" 
                :orderMenuList="orderMenuList"
                :allfoodSubCategorys="allfoodSubCategorys" 
                :disRadioOrder="posFoodSetMealInfos" 
                @confirm="confirm"
                :BindPosFoods="BindPosFoods" 
                @BindPosconfirm="BindPosconfirm"
            ></demand-model>
        </modal-load>
        <!-- 套餐替换菜品 -->
        <modal-load :isShow="selectFootShow" isUnload>
            <select-foot-model :isShow="selectFootShow" :data="replaceData" :notFoodIds="notFoodIds" @close="selectFootShow=false" @change="selectConfirm"/>
        </modal-load>
        <!-- 换核销菜 -->
        <modal-load :isShow="selectItemShow">
            <select-item-model :isShow="selectItemShow" :defaultVal="posFoodSetMealInfos" :data="couponItemList" @close="selectItemShow=false" @change="selectItem"/>
        </modal-load>
    </modal>
</template>

<script>

import { newGuid,deepClone } from '/src/common/index.js'
import DemandModel from '../../diningDetail/demandModel/demandModel.vue'
import selectFootModel from '../../diningDetail/setMealModel/selectFootModel/selectFootModel.vue'

/**快餐卡券核销下单并结账 */
export default {
    name:"couponVerifyModel",
    emits:["close","confirm"],
    components:{
        DemandModel,
        selectFootModel
    },
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        //菜品所有类别
        allfoodSubCategorys:{
            type:Object,
            default:null
        },
        /**餐厅ID */
        RoomAutoID:{
            type:String,
            default:""
        },
        /**桌台名称 */
        DeskName:{
            type:String,
            default:""
        },
        /**桌台ID */
        DeskAutoID:{
            type:String,
            default:""
        },
        /**订单抬头信息 */
        headingInfo:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            masKindsList:'', //菜品口味
            orderMenuList:'', //订单菜品数据
            //查询码
            idCode:'',
            /**券数据 */
            ticketInfos:[],
            /**选中的券 */
            selectCoupon:'',
            /**菜品信息 */
            posFoodData:'',
            demandShow:false,
            //套餐子菜 选口味
            BindPosFoods:null,
            choosemasKind:[], //选择的口味
            posFoodSetMealInfos:'',//临时菜品数据
            /**套餐子菜替换 */
            isReplace:false,
            /**是否判断 强制套餐明细 口味做法 */
            isDemand:true,
            /**当前操作的菜品 */ 
            currentItem:null,
            /** 套餐替换菜品 弹层*/
            selectFootShow:false,
            /**要换菜的数据 */
            replaceData:null,
            /**换核销菜品 弹层 */
            selectItemShow:false,
            /**选中券 匹配到的菜品 */
            couponItemList:[]
        }
    },
    computed:{
        globalSysSetting(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting;
        },
        //系统券平台类型4:翼码5:正品
        CouponPlatform_Type(){
            if(this.globalSysSetting?.CouponPlatform_Type==4 || this.globalSysSetting?.CouponPlatform_Type==5){
                return this.globalSysSetting.CouponPlatform_Type;
            }
            return 4;
        },
        /**启用【当套餐子项沽清时，允许下单】， true:开启 false:未开启 */
        isSoldOutDetails(){
            return this.globalSysSetting?.RunAllowSetmealOrderInWIthSoldOutDetails;
        },
        /**是否有 可替换菜品的分类 */
        isReplaceShow(){
            return this.posFoodSetMealInfos?.SetMealInfo?.SetMealKinds?.some(it=>it.ReplaceType==1 || it.ReplaceType==2);
        },
        /**需要排除的菜品id */
        notFoodIds(){
            let ids=[];
            this.posFoodSetMealInfos?.SetMealInfo?.SetMealKinds?.forEach(set=>{
                set.SetMealDetails?.forEach(it=>{
                    if(this.currentItem.SetMealDetail_ID!=it.SetMealDetail_ID){//排除当前的菜
                        if(it.Food_ID){
                            ids.push(it.Food_ID);
                            if(it.replaceItem){
                                ids.push(it.replaceItem.Food_ID);
                            }
                        }
                    }
                })
            })
            return ids;
        }
    },
    mounted(){
        //菜品数据结构
        this.$cacheData.PosFoods().then((d)=>{
            this.posFoodData = d.data
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        /**菜品口味 */
        this.$cacheData.MasKinds().then((d)=>{
            this.masKindsList = d;
        }).catch(e=>{
            this.$alert("菜品口味数据获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
        this.init();
    }, 
    watch: {
        isShow(newVal) {
            if(newVal){
                this.init();
            }   
        }
    },
    methods:{
        /**安卓 扫码 */
		scanCode() {
			if (window.webview) {
				this.$webBrowser.hasCamera().then((isQr) => {
					if (isQr == "1") {
						this.$webBrowser.qr().then((d) => {
							this.idCode=d;
                            this.readCard();
						}).catch((e) => {
							this.$message({ message: "扫码失败:" + e, type: "warning" });
						});
					} 
				});
			} 
		},
        init(){
            this.isReplace=false;
            this.BindPosFoods=null;
            this.selectCoupon='';

            this.choosemasKind=[];
            this.posFoodSetMealInfos='';
            this.demandShow=false;
            this.idCode='';
            this.ticketInfos=[];
            setTimeout(() => {
                this.$refs.input.focus();
            },100);
            this.orderMenuList = [];
        },
        readCard(){
            if(!this.idCode){
                this.$message.warning('查询码不能为空');
                return
            }
            let userInfo=this.$auth.getUserInfo()
            //获取平台券信息
            let param={
                Body_ID:newGuid(),
                User_ID:userInfo?.User_ID,
                Platform_Type:this.CouponPlatform_Type, //平台类型 1:抖音 2:美团 3:口碑 4: 翼码
                Dynamic_Code:this.idCode,
                Dynamic_Type:'',//查询码类型，mobile : 按手机号查询 ，不传按默认查询类型
            }
            if(sessionStorage.getItem("tempUserID")){
                param.User_ID = sessionStorage.getItem("tempUserID")
            }
            const loading = this.$loading({
                text: "获取券信息中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CouponPlatform.GetCouponInfo",param).then((data)=>{
                console.log(data)
                loading.close();
                this.$refs.input?.focus();
                this.$refs.input?.select();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc)
                }else{
                    this.ticketInfos = data?.ResponseBody
                    this.ticketInfos?.forEach(tick=>{
                        Object.assign(tick,{Check:false,extendShow:false})
                    })
                    this.choosemasKind=[],this.posFoodSetMealInfos='',this.selectCoupon=''
                    if(this.ticketInfos?.length==1){
                        this.onTicket(this.ticketInfos[0]);
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**口味选择返回 */
        confirm(optFlavors,disRadioOrder){
            this.demandShow=false
            if(optFlavors){
                this.choosemasKind=[]
                optFlavors.forEach(op=>{
                    let flavor ={
                        IsAllRequired:0,
                        Mas_AutoID:op.Mas_AutoID,
                        Mas_Code:op.Mas_Code,
                        Mas_Name:op.Mas_Name,
                        Mas_Price:op.Mas_Price,
                        Is_AddMoney:op.Is_AddMoney,
                        Price_Kind:op.Price_Kind
                    }
                    this.choosemasKind.push(flavor)
                })
            }
            this.posFoodSetMealInfos.FoodModifys = this.choosemasKind
            
        },
        /**删除口味选择 */
        deleteMasClick(mas){
            this.choosemasKind.forEach((kind,i)=>{
                /**找到选择口味对应的菜品 */
                if(kind.Mas_AutoID==mas.Mas_AutoID){
                    this.choosemasKind.splice(i,1)
                }
            })
            this.posFoodSetMealInfos.FoodModifys = this.choosemasKind
        },
        //核销
        async cancelConfirm(){
            if(!this.posFoodSetMealInfos){
                this.$message.warning('请先选择需要核销的商品券!');
                return
            }
            if(this.posFoodSetMealInfos.Is_SetMeal){//套餐
                let error=[];
                if(!this.posFoodSetMealInfos.SetMealInfo?.SetMealKinds){
                    this.$message.warning('套餐没有子项菜品,请先选择子菜!');
                    return
                }
                let SetMealKinds=this.posFoodSetMealInfos.SetMealInfo?.SetMealKinds;
                for(let i=0;i<SetMealKinds.length;i++){
                    let itemNumCount=0;
                    let item=SetMealKinds[i];
                    for(let j=0;j<item.SetMealDetails.length;j++){
                        let set=item.SetMealDetails[j];
                        if(set.Is_Selected){
                            if(!this.isSoldOutDetails && ((set?.replaceItem && set?.replaceItem?.Is_SoldOut) || (!set?.replaceItem && set?.Is_SoldOut))){
                                this.$message.warning((set?.replaceItem?.Food_Name||set.Food_Name)+'已沽清,无法核销!');
                                return;
                            }
                            itemNumCount+=set.Food_Number;
                            if(this.isDemand && set.Is_BindEatMas && !(set._FoodModifys?.length>0)){//有口味做法要求
                                if(set.replaceItem && set.replaceItem.Is_BindEatMas){
                                    error.push("【"+set.replaceItem.Food_Name+"】");
                                }else if(!set.replaceItem && set.Is_BindEatMas){
                                    error.push("【"+set.Food_Name+"】");
                                }
                                
                            }
                        }
                    }
                    if(itemNumCount<item.Select_Number || itemNumCount>item.Count_Number){
                        let title=item.Kind_Name+"分类下【最少选"+item.Select_Number+"份，最多选"+item.Count_Number+"份】，您选择了"+itemNumCount+"份，请修改【"+item.Kind_Name+"】分类下菜品份数！"
                        this.$alert(title, "提示", {confirmButtonText: "确定"});
                        this.$refs.nav?.querySelectorAll(".nav-li")[i+1]?.click();
                        return;
                    }
                }

                if(error.length>0){
                    //是否开启如套餐子项菜品未选择绑定做法，则不允许点此套餐， true:开启 false:未开启
                    if(this.sysSetting?.RunSetmealDetailRefusedOrderInWithoutBindMas){
                        this.$alert("套餐中"+error.join(",")+'菜品未选择做法!', "提示", {confirmButtonText: "确定"});
                        return
                    }else{
                        try {
                            await this.$confirm("套餐中"+error.join(",")+'菜品未选择做法，是否继续核销？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            })
                        } catch (error) {
                            return;
                        } 
                    }
                }
            }

            let userInfo=this.$auth.getUserInfo()
            let param={
                User_ID:userInfo?.User_ID,
                Operator_Name:userInfo?.Login_Name, //操作员
                Room_ID:this.RoomAutoID,
                Eat_DeskID:this.DeskAutoID,//桌台ID
                Eat_DeskName:this.DeskName,//桌台名称
                Order_BatchNo:newGuid(),//下单批次号
                OrderConsumes:this.orderConsumeData(),//券码对应的商品明细
                Platform_Type:this.CouponPlatform_Type, //平台类型 1:抖音 2:美团 3:口碑 4: 翼码
                Channel_ID:this.selectCoupon?.Channel_ID,//渠道ID this.selectCoupon?.Channel_ID
                Coupon_AutoId:this.selectCoupon?.Coupon_TemplateId,//券模板ID
                Coupon_Code:this.selectCoupon?.Coupon_Code,//选择核销的券码
                Coupon_Name:this.selectCoupon?.Coupon_Name,//选择核销的券名称
                Coupon_VerifyToken:this.selectCoupon?.Coupon_VerifyToken,//验券的标识
                Scene_Type:1, //可用场景
                Merchant_FactAmount:this.selectCoupon?.Merchant_FactAmount,//券商家实收金额
            }
            if(this.selectCoupon?.Coupon_Type==4){
                param.Time_Card=this.selectCoupon.Time_Card;//次卡信息
                param.Platform_OrderId=this.selectCoupon.Platform_OrderId;//平台订单ID
            }
            if(sessionStorage.getItem("tempUserID")){
                param.User_ID = sessionStorage.getItem("tempUserID")
                param.Operator_Name = sessionStorage.getItem("tempName")
                sessionStorage.removeItem("tempUserID")
                sessionStorage.removeItem("tempName")
            }
            console.log('卡券核销 请求参数:',param);
            const loading = this.$loading({
                text: "核销中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CouponPlatform.CouponVerifyInOrderAndCheckOut",param).then((data)=>{
                console.log('卡券核销 返回参数:',data)
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc)
                }else{
                    this.$emit('confirm',data);//核销结束
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
         /**订单消费数据 */
        orderConsumeData(){
            let order={
                Food_ID:this.posFoodSetMealInfos.Food_ID,//菜品ID
                Food_Code:this.posFoodSetMealInfos.Food_Code,//菜品编号
                Food_Name:this.posFoodSetMealInfos.Food_Name,//菜品名称
                Food_Size:this.posFoodSetMealInfos.Food_Size,//菜品单位
                Food_Type:1,//菜品类型 ，1：单菜 2：套餐 3：临时套餐 5：拼盘
                Food_Speed:'即',//菜品厨房速度， 即、等叫、加急，先上，后上
                Food_Number:1,//菜品数量
                Food_AssNumber:0, //菜品辅助数量
                Food_Price:this.posFoodSetMealInfos.Food_Price, //菜品单价
                FoodModifys:this.choosemasKind, //菜品做法要求
                FoodSetmeals:[], //套餐子项菜品
            }
            //菜品做法要求
            if(this.choosemasKind){
                order.FoodModifys=this.choosemasKind.map(num=>{
                    let json={
                        Mas_AutoID:num.Mas_AutoID,
                        Mas_Code:num.Mas_Code,
                        Mas_Name:num.Mas_Name,
                        Mas_Num:1,
                        Mas_Price:num.Mas_Price,
                        Price_Kind:num.Price_Kind,
                        Is_AddMoney:num.Is_AddMoney,
                    }
                    //加价的做法口味
                    if(num.Is_AddMoney){
                        if(num.Price_Kind==0){//按量加价
                            json.Mas_Num=1;
                        }else if(num.Price_Kind==1){//按次加价
                            json.Mas_Num=1;
                        }else if(num.Price_Kind==2){//按位加价
                            json.Mas_Num=this.headingInfo?.DinersNum||1;//人数是多少，加价数量就是多少
                        }
                    }
                    return json;
                })
            }
            /**如果是套餐 */
            if(this.posFoodSetMealInfos.Is_SetMeal){
                order.Food_Type=2;//套餐
                let _SetMeal = []
                this.posFoodSetMealInfos?.SetMealInfo?.SetMealKinds.forEach(set=>{
                    set.SetMealDetails.forEach(item=>{
                        if(item.Is_Selected==true){
                            let foodSet={
                                FoodSetmeal_ID:item.Food_ID,//套餐菜品ID
                                FoodSetmeal_Code:item.Food_Code,//套餐菜品编号
                                FoodSetmeal_Name:item.Food_Name,//套餐菜品的名称
                                FoodSetmeal_Size:item.Food_Size,//套餐菜品单位
                                FoodSetmeal_Number:item.Food_Number,//套餐菜品数量
                                FoodSetmeal_AssNumber:0,//辅助数量
                                FoodSetmeal_Price:item.Food_TcPrice, //套餐加价
                                FoodSetmeal_SetPrice:item.Food_SetPrice,
                                SetMealDetail_ID:item.SetMealDetail_ID,//套餐明细子项主键ID
                                ReplaceFood_ID:item.replaceItem?.Food_ID,//替换菜id
                                FoodModifys:[] //菜品做法要求
                            }
                            //核销券套餐子项有做法
                            if(item._FoodModifys?.length>0){
                                foodSet.FoodModifys=item._FoodModifys.map(num=>{
                                    let json={
                                        Mas_AutoID:num.Mas_AutoID,
                                        Mas_Code:num.Mas_Code,
                                        Mas_Name:num.Mas_Name,
                                        Mas_Num:1,
                                        Mas_Price:num.Mas_Price,
                                        Price_Kind:num.Price_Kind,
                                        Is_AddMoney:num.Is_AddMoney,
                                    }
                                    //加价的做法口味
                                    if(num.Is_AddMoney){
                                        if(num.Price_Kind==0){//按量加价
                                            json.Mas_Num=item.Food_Number;
                                        }else if(num.Price_Kind==1){//按次加价
                                            json.Mas_Num=1;
                                        }else if(num.Price_Kind==2){//按位加价
                                            json.Mas_Num=this.headingInfo?.DinersNum||1;//人数是多少，加价数量就是多少
                                        }
                                    }
                                    return json;
                                })
                            }
                            if(this.choosemasKind){//全部口味做法
                                this.choosemasKind.forEach(num=>{
                                    let json={
                                        Mas_AutoID:num.Mas_AutoID,
                                        Mas_Code:num.Mas_Code,
                                        Mas_Name:num.Mas_Name,
                                        Mas_Num:1,
                                        Mas_Price:num.Mas_Price,
                                        Price_Kind:num.Price_Kind,
                                        Is_AddMoney:num.Is_AddMoney,
                                    }
                                    //加价的做法口味
                                    if(num.Is_AddMoney){
                                        if(num.Price_Kind==0){//按量加价
                                            json.Mas_Num=1;
                                        }else if(num.Price_Kind==1){//按次加价
                                            json.Mas_Num=1;
                                        }else if(num.Price_Kind==2){//按位加价
                                            json.Mas_Num=this.headingInfo?.Eat_ManNum||1;//人数是多少，加价数量就是多少
                                        }
                                    }
                                    foodSet.FoodModifys.push(json);
                                })
                            }
                            _SetMeal.push(foodSet)
                        }
                    })
                })
                order.FoodSetmeals=_SetMeal
            }
            return [order]
        },
        //选择口味和做法
        masClick(){
            if(!this.posFoodSetMealInfos){
                this.$message.warning('请先选择商品券!');
                return
            }
            this.demandShow=true
        },
        //关闭
        hide(){
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName")
            this.$emit('close')
        },
        /**数量增加 */
        setMealNumAdd(set,item){
            if(set?.Is_Fixed==true){
                return
            }
            if(!this.isSoldOutDetails && ((set?.replaceItem && set?.replaceItem?.Is_SoldOut) || (!set?.replaceItem && set?.Is_SoldOut))){//已经沽清
                this.$message.warning('已沽清,无法修改数量');
                return
            }
            let itemNumCount=0;
            if(set){
                item.SetMealDetails.map(i=>{
                    if(i.Is_Selected){
                        itemNumCount+=i.Food_Number
                    }
                })
                if(itemNumCount>=item.Count_Number || set.Food_Number>=item.Count_Number){
                    this.$message.warning('选择数量超过套餐限制');
                }else{
                    set.Food_Number++;
                }
            }
        },
        /**数量减少 */
        setMealNumreduce(set){
            if(set?.Is_Fixed==true){
                return
            }
            if(!this.isSoldOutDetails && ((set?.replaceItem && set?.replaceItem?.Is_SoldOut) || (!set?.replaceItem && set?.Is_SoldOut))){//已经沽清
                this.$message.warning('已沽清,无法修改数量');
                return
            }
            if(set){
                if(set.Food_Number>1){
                    set.Food_Number--;
                }else{
                    if(set.Is_Fixed==false){
                        set.Is_Selected=false;
                    }
                }
            }
        },
        /**选择菜品 */
        foodClick(set,item){
            if(!this.isSoldOutDetails && ((set?.replaceItem && set?.replaceItem?.Is_SoldOut) || (!set?.replaceItem && set?.Is_SoldOut)) && set.Is_Selected==false){
                this.$message.warning(set.Food_Name+'已沽清,无法选择');
                return
            }
            if(set.Is_Fixed==true){
                this.$message.warning(set.Food_Name+'是固定菜品,无法取消');
                return
            }
            //如果菜品数量是2，且最多和最少都是1 的时候
            let temType=0
            if(item.SetMealDetails.length==2 && item.Count_Number==1 && set.Is_Selected==false){
                item.SetMealDetails.forEach(it=>{
                    if(it.Is_Selected==true && it.Food_ID!=set.Food_ID && it.Is_Fixed==false){
                        it.Is_Selected=false
                        return true
                    }else if(it.Is_Selected==true && it.Food_ID!=set.Food_ID && it.Is_Fixed==true){
                        this.$message.warning(it.Food_Name+'是固定菜品,无法取消');
                        temType=1
                        return true
                    }
                })
            }
            if(set.Is_Selected==true){
                set.Is_Selected=false;
            }else{
                if(temType==0){
                    set.Is_Selected=true;
                }
            }
        },
        /**点击 口味要求 */
        flavourClick(item){
            this.demandShow=true;
            if(item.replaceItem){
                this.BindPosFoods = Object.assign({},item.replaceItem,{
                    _Eat_MasName:item._Eat_MasName,
                    _FoodModifys:item._FoodModifys
                });
            }else{
                this.BindPosFoods= item;
            }
            this.currentItem=item;
        },
        /**口味选择 返回 */
        BindPosconfirm(optFlavors){
            this.demandShow=false;
            this.BindPosFoods=null;
            if(optFlavors?.length>0){
                this.currentItem._Eat_MasName=optFlavors.map(it=>it.Mas_Name).join(",")
                this.currentItem._FoodModifys=optFlavors;
            }else{
                this.currentItem._Eat_MasName="";
                this.currentItem._FoodModifys=null;
            }
        },
        /**替换菜品 */
        replaceClick(kind,item){
            this.replaceData={
                ReplaceType:kind.ReplaceType,//替换菜品控制类型 0或空:不允许替换 1:任意替换 2:控制替换
                ReplaceMaxPercent:kind.ReplaceMaxPercent,//控制替换的单价上浮百分比
                ReplaceMinPercent:kind.ReplaceMinPercent,//控制替换的单价下浮百分比
                MealDetails:item,//子菜品
            }
            this.currentItem=item;
            this.selectFootShow=true;
        },
        selectConfirm(item){
            if(item.Food_ID==this.currentItem.Food_ID){
                //如何替换的菜与原有菜相同 则还原 不需要替换了
                delete this.currentItem.replaceItem;
            }else{
                //替换的菜
                this.currentItem.replaceItem=Object.assign({},item);
            }
            this.currentItem._Eat_MasName="";//清除之前的口味做法
            this.currentItem._FoodModifys=null;
            this.selectFootShow=false;
        },
        
        extenClick(item){
            if(item.extendShow==true){
                item.extendShow=false
            }else{
                item.extendShow=true
            }
        },
        //点击券
        onTicket(item){
            if(item.Coupon_Type!=3 && item.Coupon_Type!=4){
                this.$message.warning('卡券核销只支持商品券!');
                return;
            }
            if(item.FoodRange_Type==1){
                this.$message.warning('卡券核销不支持通用券!');
                return;
            }
            if(item.Coupon_Type==4){// 次卡
                if(item.Time_Card.times_count<=item.Time_Card.times_used){//没有剩余次数
                    this.$message.warning('剩余次数为0,无法继续核销!');
                    return;
                }
            }

            //时间段控制 0所有时段,1指定时段
            let date = new Date((new Date()).Format("yyyy-MM-dd 00:00:00")); //当前时间 只用年月日判断
            let Start_Time=new Date((new Date(item.Start_Time)).Format("yyyy-MM-dd 00:00:00"));
            let End_Time=new Date((new Date(item.End_Time)).Format("yyyy-MM-dd 00:00:00"));
            if(Start_Time>date || date > End_Time){
                this.$message.warning('不在该券可使用的时间范围内!');
                return
            }
            this.ticketInfos.forEach(tick=>{
                if(tick.Check==true){
                    tick.Check=false
                    this.selectCoupon=''
                }
            })
            //FoodRange_Type适用类型 1:通用券，所有商品适用，2:部分商品券
            if(item.FoodRange_Type==2){
                let title ='';
                this.couponItemList=[];
                if(item.Exchange_FoodCodes && item.Exchange_FoodCodes.length>0){
                    let foodList=[];
                    item.Exchange_FoodCodes.forEach(code=>{
                        this.posFoodData.some(pos=>{
                            return pos.FoodSubCategorys.some(sub=>{
                                return sub.PosFoods.some(food=>{
                                    if(code==food.Food_Code){
                                        foodList.push(food);
                                        return true;
                                    }else if(food.MultipleSizeFoods?.length>0){
                                        return food.MultipleSizeFoods.some(mFood=>{
                                            if(mFood.Food_Code==code){
                                                foodList.push(food);
                                                return true;
                                            }
                                            return false;
                                        })
                                    }
                                    return false;
                                })
                            })
                        })
                    })
                    if(foodList.length>0){
                        this.couponItemList=foodList;
                        this.posFoodSetMealInfos = deepClone(foodList[0]);
                        this.posFoodSetMealInfos.FoodModifys=[];
                        this.choosemasKind=[];
                        this.selectCoupon=item;
                        item.Check=true
                    }else{
                        title = '未找到编号【'+item.Exchange_FoodCodes+'】的菜品,券id【'+item.Coupon_TemplateId+'】';
                    }
                }else{
                    title="商品券没有关联商品,券id【"+item.Coupon_TemplateId+"】";
                }
                if(title){
                    this.$message.warning(title);
                    return
                }
            }
        },
        /**选中要核销的菜品 */
        selectItem(item){
            this.selectItemShow=false;
            this.posFoodSetMealInfos = deepClone(item);
            this.posFoodSetMealInfos.FoodModifys=[];
            //全部口味做法
            this.choosemasKind=[];
        }
    }
}
</script>

<style lang="sass">
@import "./couponVerifyModel.scss";
</style>